export const Processor = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0015 3.95594V2.28857M13.3346 3.9585V2.29183M6.66812 3.9585V2.28857M10.0013 17.7085V16.0418M13.3346 17.7085V16.0418M6.66797 17.7085V16.0418M16.043 13.3335H17.7096M16.043 6.66683H17.7096M16.043 10.0002H17.7096M2.29297 10.0002H3.95964M2.29297 13.3335H3.95964M2.29297 6.66683H3.95964M12.7086 9.99935C12.7086 11.4951 11.4961 12.7077 10.0003 12.7077C8.50451 12.7077 7.29195 11.4951 7.29195 9.99935C7.29195 8.50358 8.50451 7.29102 10.0003 7.29102C11.4961 7.29102 12.7086 8.50358 12.7086 9.99935ZM5.6263 16.0418H14.3763C15.2968 16.0418 16.043 15.2956 16.043 14.3752V5.62516C16.043 4.70469 15.2968 3.9585 14.3763 3.9585H5.6263C4.70583 3.9585 3.95964 4.70469 3.95964 5.62516V14.3752C3.95964 15.2956 4.70583 16.0418 5.6263 16.0418Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Processor
